// Add init function that is executed on every page/fragment render
mpro.addInitStatic(async ($container) => {

	// Find items for the plugin selector
	const $collection = $container.find('div[data-scrollbooster]');

	// No need to go further
	if (!$collection.length) {
		return;
	}

	// Load the splidejs lib (lazy)
	const { default: ScrollBooster } = await import('scrollbooster');

	$collection.each(function(){
		new ScrollBooster({
			viewport: this,
			content: this,
			scrollMode: 'native',
			direction: 'horizontal',
		});
	});
});